export default "__VITE_ASSET__D$AbyS6P__"